export default __webpack_public_path__ + "static/media/20200810_113107.1a703188.JPG";